import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getIotSeriesAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/iot-series', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getSeriesAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/iot-series', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getSeriesById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/iot-series/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createSeries = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/iot-series`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateSeries = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/iot-series/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteSeries = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/iot-series/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteSeries = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/iot-series/${id}`);
    return handleResponse(response, onSuccess, onError);
};